<template>
    <div>
        <h1 class="my-5">Automate your inbox</h1>

        <b-alert
                :show="dismissCountDown"
                dismissible
                :variant="notificationColor"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
        >
            {{ notification }}
            <ul v-if="notificationErrors" class="list-unstyled">
                <li v-for="(value, key, index) in notificationErrors">{{ value }}</li>
            </ul>
        </b-alert>

        <div v-if="loading"><img src="/loading.svg"> Loading</div>
        <div v-else-if="!openToRegister">
            <p>Want to join? Leave us your email for updates.</p>
            <a href="javascript:void(0)" class="boei-embed-open btn btn-primary">Shoot us an email</a>
        </div>
        <div v-else>
            <validation-observer ref="observer" v-slot="{ passes }">
                <form v-on:submit.prevent="passes(register)">
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <p><span class="font-weight-bold">Create your account</span></p>
                        <label class="mt-4">Email</label>
                        <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                            <b-form-input type="email" autocomplete="username" v-model="email"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>

                        <label class="mt-4">Password</label>
                        <validation-provider name="password" rules="required|min:6|max:50" v-slot="{ errors }">
                            <b-form-input type="password" autocomplete="new-password" v-model="password"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>

                        <validation-provider name="terms" rules="required" v-slot="{ errors }">
                            <b-form-checkbox class="mt-4" v-model="checkbox" value="accepted" :unchecked-value="null">I agree with the <a href="https://www.inboxgpt.ai/privacy" target="_blank">Privacy</a>, <a href="https://www.inboxgpt.ai/data-processing-agreement" target="_blank">DPA</a>, <a href="https://www.inboxgpt.ai/eula" target="_blank">EULA</a>, and <a href="https://www.inboxgpt.ai/terms" target="_blank">Terms</a>.</b-form-checkbox>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>
                    </validation-observer>

                    <button type="submit" class="btn btn-primary btn-lg btn-block mt-5">Sign up</button>
                </form>
            </validation-observer>
        </div>

        <p class="text-muted" style="margin-top: 200px;">Already have an account? <router-link to="/login">Sign in</router-link>.</p>
    </div>
</template>

<script>
    export default {
        data: () => ({
            email: '',
            password: '',
            checkbox: '',
            loading: false,
            notification: null,
            notificationColor: null,
            notificationErrors: null,
            dismissSecs: 30,
            dismissCountDown: 0,
            openToRegister: true,
        }),
        async created() {
            if('email' in this.$route.query) {
                this.email = this.$route.query.email
            }
            if('go_register' in this.$route.query) {
                this.openToRegister = true
            }
        },
        methods: {

            register: function (e) {
                var app = this
                app.loading= true
                let visitor_id = null
                let plan = null
                let template = null

                // Get visitor_id if available
                if('vid' in this.$route.query) {
                    visitor_id = this.$route.query.vid
                }

                // Get template if applicable
                if('template' in this.$route.query) {
                    template = this.$route.query.template
                }

                // Get plan if applicable
                if('plan' in this.$route.query) {
                    plan = this.$route.query.plan
                }

                // Tracking new signup
                this.$gtm.trackEvent({
                    event: 'register',
                    email: app.email,
                    domain: app.domain,
                    visitor_id: visitor_id,
                    plan: plan,
                });

                this.$auth.register({
                    data: {
                        domain: app.domain,
                        email: app.email,
                        password: app.password,
                        visitor_id: visitor_id,
                    },
                    redirect: { path: '/channels', query: {welcome: true} },
                })
                    .then((data) => { // success
                    }, (error) => { // error

                        // handle authentication and validation errors here
                        console.log('Cannot process registration')
                        console.log(error)
                        this.notify('Could not sign you up', 'danger', error.response.data.errors)
                        app.loading= false

                    });

            },

            /**
             * Notify with a message
             * @param message
             * @param color
             * @param errors
             */
            notify(message, color, errors = null) {
                this.notification = message
                this.notificationColor = color
                this.notificationErrors = errors
                this.dismissCountDown = this.dismissSecs
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
        }
    }
</script>
